import I18nKeys from 'src/utils/i18n-keys'
import i18n from 'src/assets/i18n/i18n'

export default {
  setCountries () {
    return new Promise(resolve => {
      this.setCountryOptions()
      this.setCountryValues()
      resolve()
    })
  },
  setCountryOptions () {
    const { t } = i18n().global;
    const COUNTRIES = I18nKeys.COUNTRIES.filter(
      iso => iso !== this.$store.getters['settings/iso']
    )
    this.countries.setOptions({
      obj: COUNTRIES.map(iso => {
        return {
          value: iso,
          label: t(`data.countries.${iso}`)
        }
      }),
      value: 'value',
      name: 'label',
      multiple: true
    })
  },
  setCountryValues () {
     const { t } = i18n().global;
    const orders = this.submissionImageSortorders.filter(
      item => (
        I18nKeys.COUNTRIES.indexOf(item.locationIso) > -1 &&
        item.locationIso !== this.$store.getters['settings/iso']
      )
    )
    this.countries.setValues({
      obj: orders.map(item => {
        return {
          value: item.locationIso,
          label: t(`data.countries.${item.locationIso}`)
        }
      }),
      value: 'value',
      name: 'label',
      multiple: true
    })
  },
  selectCountry (val) {
    /**
     * Update country values.
     */
    return new Promise(resolve => {
      this.updateSortOrders(val)
        .then(() => {
          this.countries.update(val, this.updateSubmission)
          resolve()
        })
    })
  },
  updateSortOrders (values) {
    /**
     * Update imageSortorders in $store with country values.
     */
    return new Promise(resolve => {
      const sortOrders = []
      /**
       * Keep Default.
       */
      this.sortOrders.some(order => {
        if (order.iso === this.$store.getters['settings/iso']) {
          sortOrders.push(order)
        }
      })
      /**
       * Add optional in values or if not exists yet.
       */
      if (values) {
        values.forEach(v => {
          if (!this.sortOrders.some(o => o.iso === v.value)) {
            sortOrders.push(this.newOrder({
              blue: v.value
            }))
          }
          this.sortOrders.some(order => {
            if (order.iso === v.value) {
              sortOrders.push(order)
            }
          })
        })
      }
      /**
       * Update.
       */
      this.sortOrders = sortOrders
      resolve()
    })
  }
}
